import { PropsWithChildren } from 'react';
import { Center } from '~/commonComponents/Center';
import { MODAL_OVERLAY_Z_INDEX } from '~/constants/layout';

export const Overlay = ({ children }: PropsWithChildren) => (
  <Center
    backgroundColor="rgba(0, 0, 0, 0.5)"
    height="100%"
    inset={0}
    overflow="hidden"
    position="fixed"
    width="100%"
    zIndex={MODAL_OVERLAY_Z_INDEX}
  >
    {children}
  </Center>
);
